import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const CardStack = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // 12 cards data using all your high-quality stack images
  const cards = [
    { 
      id: 1, 
      title: "Featured Mockup", 
      content: "Premium mockup showcase", 
      image: "/stack/mockup_1726465454654.jpg"
    },
    { 
      id: 2, 
      title: "Desktop Workspace", 
      content: "Professional desktop presentation", 
      image: "/stack/mockup_1759273714092.jpg"
    },
    { 
      id: 3, 
      title: "Creative Office", 
      content: "Innovative office environment", 
      image: "/stack/mockup_1759273848405.jpg"
    },
    { 
      id: 4, 
      title: "Tech Showcase", 
      content: "Technology demonstration", 
      image: "/stack/mockup_1759934124004.jpg"
    },
    { 
      id: 5, 
      title: "Digital Interface", 
      content: "Modern UI presentation", 
      image: "/stack/mockup_1759934216198.jpg"
    },
    { 
      id: 6, 
      title: "New Mockup Style", 
      content: "Latest mockup design", 
      image: "/stack/mockup_1760831308420.jpg"
    },
    { 
      id: 7, 
      title: "Brand Showcase", 
      content: "Brand identity mockup", 
      image: "/stack/mockup_1760004261074.jpg"
    },
    { 
      id: 8, 
      title: "Product Display", 
      content: "Product showcase mockup", 
      image: "/stack/mockup_1760004637940.jpg"
    },
    { 
      id: 9, 
      title: "Business Presentation", 
      content: "Corporate mockup design", 
      image: "/stack/mockup_1760028013055.jpg"
    },
    { 
      id: 10, 
      title: "Creative Portfolio", 
      content: "Portfolio showcase mockup", 
      image: "/stack/mockup_1760999433681.jpg"
    },
    { 
      id: 11, 
      title: "Lifestyle Scene", 
      content: "Lifestyle product showcase", 
      image: "/stack/mockup_1760034526389.jpg"
    },
    { 
      id: 12, 
      title: "Portfolio Showcase", 
      content: "Creative portfolio mockup", 
      image: "/stack/mockup_1760044459919.jpg"
    }
  ];

  const handleCardClick = () => {
    setCurrentIndex((prev) => (prev + 1) % cards.length);
  };

  // Auto-rotate every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % cards.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [cards.length]);

  return (
    <div className="relative w-full max-w-4xl mx-auto px-4 md:px-0">
      <div className="relative aspect-[4/3] w-full md:w-[36rem] mx-auto">
        {cards.map((card, index) => {
          const position = (index - currentIndex + cards.length) % cards.length;
          const isVisible = position < 6; // Show top 6 cards to make the stack more visible
          
          if (!isVisible) return null;

          const zIndex = 8 - position;
          const scale = 1 - (position * 0.05);
          const yOffset = position * 15; // Increased spacing between cards
          const rotation = position * 2;

          return (
            <motion.div
              key={card.id}
              className={`absolute w-full h-full cursor-pointer`}
              style={{
                zIndex,
                transform: `translateY(${yOffset}px) scale(${scale}) rotate(${rotation}deg)`,
              }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ 
                opacity: position === 0 ? 1 : 0.8,
                y: position === 0 ? 0 : yOffset,
                scale: scale,
                rotate: rotation
              }}
              whileHover={position === 0 ? { y: -15, scale: 1.03 } : {}}
              transition={{ 
                type: "spring", 
                stiffness: 300, 
                damping: 30,
                duration: 0.3
              }}
              onClick={handleCardClick}
            >
              <div 
                className={`
                  w-full h-full rounded-[40px] shadow-[0_40px_40px_rgba(0,0,0,0.25)] 
                  overflow-hidden
                  hover:shadow-[0_50px_50px_rgba(0,0,0,0.3)]
                  transition-all duration-300 ease-out
                  border border-white/20
                `}
              >
                <img 
                  src={card.image} 
                  alt={card.title}
                  className="w-full h-full object-cover scale-[1.01]"
                />
              </div>
            </motion.div>
          );
        })}
      </div>
      
    </div>
  );
};

export default CardStack;
